var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-white shadow overflow-hidden sm:rounded-lg" },
    [
      _c(
        "div",
        { staticClass: "px-4 py-5 border-b border-gray-200 sm:px-6" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }